import { IApiCoverageReport } from '@cbridge-packages/api-coverage';
import { ICoverageReport } from './coverageReport.interface';

export namespace CoverageReportTranslator {
  export function fromApi(report: IApiCoverageReport): ICoverageReport {
    return {
      reportId: report.id,
      name: report.name,
      serverId: report.server.id,
    };
  }
}
